<template>
  <span v-if="deposit_amount_type === 'range'"> {{ $t('ui.depositDisplay.from')}} {{ offer.offer_pricing.deposit_amount_from }} {{$t('ui.depositDisplay.to')}} {{ offer.offer_pricing.deposit_amount_to }}</span>
  <span v-else-if="deposit_amount_type === 'from'"> {{ $t('ui.depositDisplay.fromB')}} {{ offer.offer_pricing.deposit_amount_from }}</span>
  <span v-else-if="deposit_amount_type === 'unique'"> {{ offer.offer_pricing.deposit_amount_from }}</span>
</template>

<script>
export default {
  name: "DepositDisplay",
  props: {
    offer: {
      type: Object,
      required: true
    }
  },
  computed: {
    deposit_amount_type() {
      return this.offer.offer_pricing.deposit_amount_type
    }
  }
}
</script>

<style lang="scss" scoped>
</style>